import { StoreAccessor } from "mobx-firelink";
export const GetAuth = StoreAccessor("GetAuth", s => () => {
    return s.firelink.userInfo;
});
export const GetAuth_Raw = StoreAccessor("GetAuth_Raw", s => () => {
    return s.firelink.userInfo_raw;
});
